import { useEffect, useState } from "react"
import { data } from "../service/data"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as fa from "@fortawesome/free-solid-svg-icons";
import React from "react";


const Svg = React.memo(({ content_id,content ,className,style,onClick,id }) => {


const [svg,setSvg]= useState(content ? content :null)
 
useEffect(()=>{

        const getSvg= async ()=>{
          
            var _svg = await data.getContent(content_id ?? 947,true)
           
          setSvg((prevSvg) => (prevSvg !== _svg ? _svg : prevSvg)); 
        }

if(!content || !content.content ) getSvg()
},[content_id,content])

if(!svg) 
    return <></>





 if (svg) {
    return (
      <svg
    
        id={id}
        className={" svg-inline--fa  inline-block align-top my-[-1px] " +className}
        style={style}
        onClick={onClick}
        aria-hidden="true"
        focusable="false"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox={svg.content.viewBox ?? "0 0 512 512"}
        dangerouslySetInnerHTML={{ __html: svg.content.path }}
        
      />
    )
  }

return null

})
export default Svg